import React from 'react';
import { translate } from '../../../../../../../../../Services/translation';

import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { setOrderNote } from '../../../../../../../../../Actions/Checkout.action';
import CheckoutPaymentFormDetailsForm from './CheckoutPaymentFormDetailsForm';

const fields = [
  {
    id: 'firstName',
    stateKey: 'customerDetails',
    autoComplete: 'billing given-name',
  },
  {
    id: 'lastName',
    stateKey: 'customerDetails',
    autoComplete: 'billing family-name',
  },
  {
    id: 'phoneNumber',
    stateKey: 'customerDetails',
    type: 'tel',
    autoComplete: 'billing tel',
  },
  {
    id: 'email',
    stateKey: 'customerDetails',
    type: 'email',
    autoComplete: 'email',
  },
  {
    id: 'customerOrderNumber',
    stateKey: 'customerDetails',
    autoComplete: 'billing customer-order-number',
    cssClass: 'md:col-span-2',
  },
];

const alternateAdressFields = [
  {
    id: 'address',
    stateKey: 'alternativeCompanyAddress',
  },
  {
    id: 'careOf',
    stateKey: 'alternativeCompanyAddress',
  },
  {
    id: 'zipCode',
    stateKey: 'alternativeCompanyAddress',
  },
  {
    id: 'city',
    stateKey: 'alternativeCompanyAddress',
  },
];

const CheckoutPaymentFormDetailsB2B = ({ checkout, onChange }) => {
  const { payload } = checkout || {};
  const {
    authenticated,
    companyAddresses,
    isAlternativeCompanyAddressAllowed,
    selectedCompanyAddressId,
    orderNote,
  } = payload || {};

  const dispatch = useDispatch();
  const handleSetOrderNote = (note) => dispatch(setOrderNote(note));

  return (
    <>
      <CheckoutPaymentFormDetailsForm
        checkout={checkout}
        fields={fields}
        disabled={!authenticated}
        onChange={onChange}
        className="mb-8"
      />

      {!isAlternativeCompanyAddressAllowed ? (
        <CheckoutPaymentFormDetailsForm
          checkout={checkout}
          fields={alternateAdressFields}
          disabled={!authenticated}
          onChange={onChange}
          className="mb-8"
        />
      ) : (
        <div className="mb-8">
          <label
            className="body-sm leading-base mb-1 inline-block text-[#666666]"
            htmlFor="companyAddress"
          >
            {translate('checkout.company.address')}
          </label>
          <select
            id="companyAddress"
            className="form__input"
            value={selectedCompanyAddressId || ''}
            onChange={(event) =>
              onChange('companyAddress', 'systemId', event.target.value)
            }
          >
            <option value="" disabled>
              {translate('checkout.company.address.select')}
            </option>
            {companyAddresses.map(({ address, systemId }) => (
              <option value={systemId} key={systemId}>
                {address}
              </option>
            ))}
          </select>
        </div>
      )}

      <div>
        <label
          className="body-sm leading-base mb-1 inline-block text-[#666666]"
          htmlFor="orderNote"
        >
          {translate('checkout.order.message')}
        </label>
        <textarea
          className="form__input block"
          id="orderNote"
          value={orderNote}
          onChange={(event) => handleSetOrderNote(event.target.value)}
        />
      </div>
    </>
  );
};

CheckoutPaymentFormDetailsB2B.propTypes = {
  checkout: PropTypes.object,
  onChange: PropTypes.func.isRequired,
};

export default CheckoutPaymentFormDetailsB2B;
